import * as React from 'react';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';

const ExploreMegaMenuGridItem = () => {
  const { hasEnrolledPrograms, isCourseraPlusLearner } = useConsumerMyPageHeader();

  return (
    <MegaMenuLinksProvider>
      <div className="rc-ExploreMegaMenuGridItem">
        <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={!isCourseraPlusLearner && !hasEnrolledPrograms} />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
